export class CreditAlert {
  constructor(
    public id: number,
    public percentageLimit: number,
    public sendEmailNotification: boolean,
    public enabled?: boolean,
    public order?: number
  ) {}
}
